<template>
  <el-dialog
    :title="!textForm.textId ? 'Create Text' : 'Update Text'"
    :visible.sync="textFormVisible">
    <h4>Text:</h4>
    <el-form :model="textForm" @submit.native.prevent>
      <el-form-item>
        <el-input v-model="textForm.text" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="textForm.fontSize" placeholder="Select font size">
          <el-option v-for="size in fontSizes"
            :key="size.value"
            :label="size.label"
            :value="size.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="textForm.fontFamily" placeholder="Select font face">
          <el-option v-for="font in fontFaces"
            :key="font.value"
            :label="font.label"
            :value="font.value"
            :style="{ fontFamily: font.value }"/>
        </el-select>
      </el-form-item>
    </el-form>

    <pre v-if="SHOW_DEBUG">{{textForm.textId}}</pre>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="!isNewForm" type="danger" @click="onDelete">Delete</el-button>
      <el-button @click="textFormVisible = false">Close</el-button>
      <el-button type="primary" @click="updateTextWithFormData(textForm.textId)">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import { fontSizes, fontFaces } from './availableSettings';

export default {
  data: () => ({
    isNewForm: false,
    textForm : {
      textId: null,
      text: '',
      fontSize: 28,
      fontFamily: 'Arial'
    },
    fontSizes: fontSizes,
    fontFaces: fontFaces,
    textFormVisible: false,
  }),
  computed: {
    // ...mapGetters("goal", [
    // ])
  },
  methods: {
    // ...mapActions("goal", [
    // ]),

    showNewModal() {
      this.showUpdateModal();
      this.isNewForm = true;
    },

    showUpdateModal( data ) {
      console.log("showTextUpdateForm");
      // var textIndex = this.getIndexForTextId(textId);
      // this.textForm.textId = textId;
      // this.textForm.text = this.texts[textIndex].text;
      if ( data && data.textId ) {
        console.log("updateing not adding");
        // this.textForm = Object.assign({}, data);
        this.textForm = {
          textId: data.textId,
          text: data.text,
          fontSize: data.fontSize,
          fontFamily: data.fontFamily,
        };
      } else {
        // TODO: default values
        this.textForm.textId   = null;
        this.textForm.text     = '';
      }
      this.isNewForm = false;
      this.textFormVisible = true;
    },

    updateTextWithFormData(textId) {
      console.log("updateTextWithFormData");
      // var textIndex = this.getIndexForTextId(textId);
      // this.texts[textIndex].text = this.textForm.text;
      this.textFormVisible = false;
      this.$emit('save', this.textForm)
    },

    updateAllHeadlinePositions() {
      // this.goals.forEach((_, idx) => {
      //   // update commitment positions
      //   this.goals[idx].headline.y =  this.goals[idx].image.y - this.stageSettings.allHeadlinesFontSize * 1.2;
      //   this.goals[idx].headline.x =  this.goals[idx].image.x;
      // });
    },

    onDelete() {
      this.$emit('delete', { textId: this.textForm.textId })
      this.textFormVisible = false;
    }
  },
  components: {
  }
}
</script>
